import { Box, Card, Container, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { News } from '../config/types';
import { Link } from 'react-router-dom';


export const host = process.env.REACT_APP_TVAPP_SERVER_HOST;

const Contact = () => {
    const [lists, setList] = useState<News[]>([]);

    const getNewsList = async () => {
        const url = host + '/data/api.tvAppOpenApi/getNewsList';


        const data = {};

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const responseData = await response.json();


            if (responseData.code === 1) {
                setList(responseData.data)
            }

            console.log(responseData);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getNewsList();
    }, [])

    return <Layout>
        {/* page content */}
        <div className="w3l-innerblock"></div>
        <section className="w3l-contact-2 py-5" id="contact">
            <div className="container py-lg-5 py-md-4 py-2">
                <div className="title-content text-center">
                    <h6 className="title-subhny text-center">联系我们</h6>
                    <h3 className="title-w3l mb-sm-5 mb-4 pb-sm-o pb-2 text-center">为孩子预约课程试听</h3>
                </div>
                <div className="contact-grids d-grid">
                    <div className="contact-left-img">
                        <div className="cont-details">
                            <h2>渝北区</h2>
                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>恒大世纪城校区</h6>
                                    <p>渝北区湖红路270号附13号</p>
                                    <p><a href="tel:+(86) 199 2359 0197">+(86) 199 2359 0197</a></p>
                                </div>
                            </div>

                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>礼嘉校区</h6>
                                    <p>北部新区嘉吉路2号30幢附1号1-7</p>
                                    <p><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></p>
                                </div>
                            </div>

                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>凡尔赛校区</h6>
                                    <p>融创凡尔赛领馆二期 SP2栋-1单元-214</p>
                                    <p><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contact-left-img">
                        <div className="cont-details">
                            <h2>沙坪坝区</h2>
                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>金科廊桥校区</h6>
                                    <p>沙坪坝区大学城南二路1096号附12号2-4</p>
                                    <p><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></p>
                                </div>
                            </div>

                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>龙湖拉特芳斯校区</h6>
                                    <p>沙坪坝区微电园龙湖拉特芳斯</p>
                                    <p><a href="tel:+(86) 138 8364 1232">+(86) 138 8364 1232</a></p>
                                </div>
                            </div>

                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>康田紫悦府校区</h6>
                                    <p>沙坪坝区大学城中路（裙楼）18号附79号</p>
                                    <p><a href="tel:+(86) 130 6236 1250">+(86) 130 6236 1250</a></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contact-left-img">
                        <div className="cont-details">
                            <h2>南岸区</h2>
                            <div className="cont-top margin-up">
                                <div className="cont-left text-center">
                                    <span className="fa fa-map-marker"></span>
                                </div>

                                <div className="cont-right">
                                    <h6>铜元局校区</h6>
                                    <p>南岸区铜元局金泽路2号</p>
                                    <p><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div className="map-iframe mt-5 mb-lg-5 pb-lg-4">

                </div>
            </div>
        </section>
        {/* page content end*/}
    </Layout>
}
export default Contact;